import React, { Component } from 'react';
import axios from 'axios';
import './CreateRecordModal.css';

class CreateRecordModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoadExisting: false,
            itemNumbers: [],
            itemNumber: '',
            itemNumberSearch: '',
            selectedRfqId: null,
            selectedSharepointLink: '',
            customers: [],
            selectedCustomer: null,
            customerSearch: '',
            selectedOrderType: '',
            showItemDropdown: false,
            showCustomerDropdown: false,
            itemNumbersLoading: false
        };
    }

    componentDidMount() {
        if (this.props.isOpen) {
            this.loadItemNumbers();
            this.loadCustomers();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.loadItemNumbers();
            this.loadCustomers();
        }
    }

    loadItemNumbers = async () => {
        try {
            this.setState({ itemNumbersLoading: true });
            const response = await axios.get('/rfq/airtable-formulas');
            if (response.data && response.data.success) {
                // Transform the Airtable data to match the expected format
                // Filter out items with null names
                const itemNumbers = response.data.data
                    .filter(item => item.name != null)
                    .map(item => ({
                        itemNumber: item.name,
                        rfqId: item.id,
                        sharepointLink: item.sharepointLink
                    }));
                this.setState({ itemNumbers: itemNumbers, itemNumbersLoading: false });
            } else {
                this.setState({ itemNumbersLoading: false });
            }
        } catch (error) {
            console.error('Error loading item numbers:', error);
            this.setState({ itemNumbersLoading: false });
        }
    };

    loadCustomers = async () => {
        try {
            const response = await axios.get('/customer-list-databricks');

            if (response.data && response.data.data && Array.isArray(response.data.data)) {
                // Store full customer objects, filtered for those with customer_name
                const customers = response.data.data
                    .filter(customer => customer.customer_name)
                    .sort((a, b) => a.customer_name.localeCompare(b.customer_name));

                this.setState({ customers: customers });
            }
        } catch (error) {
            console.error('Error loading customers:', error);
        }
    };

    handleNewFormula = () => {
        window.location.href = '/request-quote/new';
    };

    handleExistingFormula = () => {
        this.setState({ showLoadExisting: true });
    };

    handleCloseLoadExisting = () => {
        this.setState({
            showLoadExisting: false,
            itemNumber: '',
            itemNumberSearch: '',
            selectedRfqId: null,
            selectedSharepointLink: '',
            selectedCustomer: null,
            customerSearch: '',
            selectedOrderType: '',
            showItemDropdown: false,
            showCustomerDropdown: false
        });
    };

    handleItemNumberSearchChange = (e) => {
        this.setState({
            itemNumberSearch: e.target.value,
            showItemDropdown: true
        });
    };

    handleItemNumberSelect = (item) => {
        this.setState({
            itemNumber: item.itemNumber,
            itemNumberSearch: item.itemNumber,
            selectedRfqId: item.rfqId,
            selectedSharepointLink: item.sharepointLink || '',
            showItemDropdown: false
        });
    };

    handleItemNumberFocus = () => {
        this.setState({ showItemDropdown: true });
    };

    handleItemNumberBlur = () => {
        setTimeout(() => {
            this.setState({ showItemDropdown: false });
        }, 200);
    };

    handleCustomerSearchChange = (e) => {
        this.setState({
            customerSearch: e.target.value,
            showCustomerDropdown: true
        });
    };

    handleCustomerSelect = (customer) => {
        this.setState({
            selectedCustomer: customer,
            customerSearch: customer.customer_name,
            showCustomerDropdown: false
        });
    };

    handleCustomerFocus = () => {
        this.setState({ showCustomerDropdown: true });
    };

    handleCustomerBlur = () => {
        setTimeout(() => {
            this.setState({ showCustomerDropdown: false });
        }, 200);
    };

    handleOrderTypeChange = (e) => {
        this.setState({ selectedOrderType: e.target.value });
    };

    handleLoadExistingSubmit = async () => {
        const { selectedRfqId, itemNumber, selectedSharepointLink, selectedCustomer, selectedOrderType } = this.state;

        try {
            const response = await axios.post('/store-to-temp-and-loadrfq', {
                id: selectedRfqId,
                itemNumber: itemNumber,
                sharepointLink: selectedSharepointLink,
                customer: selectedCustomer,
                orderType: selectedOrderType
            });

            if (response.data && response.data.success) {
                const rfqTempId = response.data.rfqTempId;
                window.location.href = `/request-quote/new?tempId=${rfqTempId}`;
            }
        } catch (error) {
            console.error('Error creating RFQ from existing:', error);
            alert('Failed to create RFQ. Please try again.');
        }
    };

    getFilteredItemNumbers = () => {
        const { itemNumbers, itemNumberSearch } = this.state;
        if (!itemNumberSearch) return itemNumbers;
        return itemNumbers.filter(item =>
            item.itemNumber.toLowerCase().includes(itemNumberSearch.toLowerCase())
        );
    };

    getFilteredCustomers = () => {
        const { customers, customerSearch } = this.state;
        if (!customerSearch) return customers;
        return customers.filter(customer =>
            customer.customer_name.toLowerCase().includes(customerSearch.toLowerCase())
        );
    };

    render() {
        const { isOpen, onClose } = this.props;
        const {
            showLoadExisting,
            itemNumber,
            itemNumberSearch,
            selectedSharepointLink,
            customerSearch,
            selectedCustomer,
            selectedOrderType,
            showItemDropdown,
            showCustomerDropdown,
            itemNumbersLoading
        } = this.state;

        if (!isOpen) return null;

        const filteredItemNumbers = this.getFilteredItemNumbers();
        const filteredCustomers = this.getFilteredCustomers();

        if (showLoadExisting) {
            return (
                <div className="modal-overlay">
                    <div className="load-existing-modal">
                        <button className="modal-close-btn" onClick={this.handleCloseLoadExisting}>×</button>
                        <h3>Load Existing Formula</h3>
                        <p className="modal-subtitle">Search for an item number and select a customer to load the formula</p>

                        <div className="form-group">
                            <label>Enter Item Number</label>
                            <div className="searchable-select">
                                <div className="input-with-icon">
                                    <i className="ti-search"></i>
                                    <input
                                        type="text"
                                        style={{padding:'10px 12px 10px 30px'}}
                                        placeholder={itemNumbersLoading ? "Loading..." : "1953-Pack-120"}
                                        value={itemNumberSearch}
                                        onChange={this.handleItemNumberSearchChange}
                                        onFocus={this.handleItemNumberFocus}
                                        onBlur={this.handleItemNumberBlur}
                                        disabled={itemNumbersLoading}
                                    />
                                </div>
                                {showItemDropdown && itemNumbersLoading && (
                                    <div className="dropdown-list">
                                        <div className="dropdown-item" style={{textAlign: 'center', color: '#999'}}>
                                            Loading item numbers...
                                        </div>
                                    </div>
                                )}
                                {showItemDropdown && !itemNumbersLoading && filteredItemNumbers.length > 0 && (
                                    <div className="dropdown-list">
                                        {filteredItemNumbers.map((item, index) => (
                                            <div
                                                key={index}
                                                className="dropdown-item"
                                                onClick={() => this.handleItemNumberSelect(item)}
                                            >
                                                {item.itemNumber}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        {itemNumber && selectedSharepointLink && (
                            <div className="form-group">
                                <label>Latest Sharepoint Link</label>
                                <div className="sharepoint-link-container">
                                    <div className="sharepoint-link-wrapper">
                                        <i className="ti-link"></i>
                                        <input
                                            type="text"
                                            style={{padding:'10px 12px 10px 30px'}}
                                            className="sharepoint-link-input"
                                            value={selectedSharepointLink}
                                            readOnly
                                        />
                                    </div>
                                    <i
                                        className="ti-new-window sharepoint-open-icon"
                                        onClick={() => window.open(selectedSharepointLink, '_blank')}
                                        title="Open in new tab"
                                    ></i>
                                </div>
                            </div>
                        )}

                        {itemNumber && (
                            <div className="form-group">
                                <label>Select Customer</label>
                                <div className="searchable-select">
                                    <div className="input-with-icon">
                                        <i className="ti-search"></i>
                                        <input
                                            type="text"
                                            style={{padding:'10px 12px 10px 30px'}}
                                            placeholder="VitalWell Labs"
                                            value={customerSearch}
                                            onChange={this.handleCustomerSearchChange}
                                            onFocus={this.handleCustomerFocus}
                                            onBlur={this.handleCustomerBlur}
                                        />
                                    </div>
                                    {showCustomerDropdown && filteredCustomers.length > 0 && (
                                        <div className="dropdown-list">
                                            {filteredCustomers.map((customer, index) => (
                                                <div
                                                    key={index}
                                                    className="dropdown-item"
                                                    onClick={() => this.handleCustomerSelect(customer)}
                                                >
                                                    {customer.customer_name}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {itemNumber && selectedCustomer && (
                            <div className="form-group">
                                <label>Order Type</label>
                                <select
                                    value={selectedOrderType}
                                    onChange={this.handleOrderTypeChange}
                                    className="order-type-select"
                                >
                                    <option value="">Select Order Type</option>
                                    <option value="Reorder">Reorder</option>
                                    <option value="NPD">NPD</option>
                                    <option value="Re-Formulation">Re-Formulation</option>
                                    <option value="New to APEX Product">New to APEX Product</option>
                                    <option value="Blanket">Blanket</option>
                                    <option value="Change Order">Change Order</option>
                                </select>
                            </div>
                        )}

                        {itemNumber && selectedCustomer && selectedOrderType && (
                            <div className="form-actions">
                                <button className="load-rfq-btn" onClick={this.handleLoadExistingSubmit}>
                                    Load RFQ
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            );
        }

        return (
            <div className="modal-overlay">
                <div className="create-modal">
                    <h3>Create a New Record</h3>
                    <p className="modal-subtitle">Choose how you would like to create your formula:</p>

                    <div className="modal-option" onClick={this.handleNewFormula}>
                        <h4>NEW FORMULA</h4>
                        <p>Start a fresh formula from scratch</p>
                    </div>

                    <div className="modal-option" onClick={this.handleExistingFormula}>
                        <h4>EXISTING FORMULA</h4>
                        <p>Build from existing formula item number</p>
                    </div>

                    <button className="modal-cancel" onClick={onClose}>Cancel</button>
                </div>
            </div>
        );
    }
}

export default CreateRecordModal;
